import { Alert, Box, Form, Grid, Link, SpaceBetween } from '@amzn/awsui-components-core';
import { RepoType } from '@amzn/awscat-pattern-library-service-model';
import React, { useContext } from 'react';
import constants from '../../../../../common/constants';
import { CodeRepoFormCtx } from './CodeRepoFormContext';
import { BranchFormField } from './BranchFormField';
import { OpenSourceReviewStatusFormField } from './OpenSourceReviewStatusFormField';
import { OpenSourceReviewUrlFormField } from './OpenSourceReviewUrlFormField';
import { RepositoryUrlFormField } from './RepositoryUrlFormField';
import { SecurityReviewStatusFormField } from './SecurityReviewStatusFormField';
import { SecurityReviewUrlFormField } from './SecurityReviewUrlFormField';
import { TitleFormField } from './TitleFormField';
import { SecurityGuardianFormField } from './SecurityGuardianFormField';

const CodeRepoForm = () => {
  // @ts-expect-error TS2339 - strict migration
  const { repoData } = useContext(CodeRepoFormCtx);

  const openSourceReviewFormFields =
    repoData.repoType === RepoType.External ? (
      <>
        <Grid gridDefinition={[{ colspan: 9 }, { colspan: 3 }]}>
          <OpenSourceReviewUrlFormField />
          <OpenSourceReviewStatusFormField />
        </Grid>
      </>
    ) : null;

  return (
    <Form>
      <SpaceBetween direction="vertical" size="m">
        <Box variant="p">
          {constants.CODE_REPO_MODAL_INFO_PART_1}{' '}
          <Link
            external
            href="https://w.amazon.com/bin/viewrev/AWS_IT_Security/Security_Reviews/AppSec-content-review-process"
          >
            {constants.CODE_REPO_MODAL_INFO_LINK_TEXT_1}
          </Link>{' '}
          {constants.CODE_REPO_MODAL_INFO_PART_2}
        </Box>
        <Box>{constants.CODE_REPO_MODAL_INFO_PART_3}</Box>
        <Grid gridDefinition={[{ colspan: 7 }, { colspan: 5 }]}>
          <RepositoryUrlFormField />
          <TitleFormField />
        </Grid>
        <Grid gridDefinition={[{ colspan: 9 }, { colspan: 3 }]}>
          <BranchFormField />
        </Grid>
        {repoData.repoType === RepoType.Internal ? (
          <Alert>{constants.CODE_REPO_INTERNAL_NOTICE}</Alert>
        ) : null}
        <Grid gridDefinition={[{ colspan: 9 }, { colspan: 3 }]}>
          <SecurityReviewUrlFormField />
          <SecurityReviewStatusFormField />
        </Grid>
        <Grid gridDefinition={[{ colspan: 12 }]}>
          <SecurityGuardianFormField />
        </Grid>
        {openSourceReviewFormFields}
      </SpaceBetween>
    </Form>
  );
};

export default CodeRepoForm;
